import { CSSProperties } from 'react';
import { PosEnumSelect } from 'src/core/POS/PosSelect/PosEnumSelect';
import { useSimplifiedUndercutMode } from 'src/hooks/useSimplifiedUndercutMode';
import { SimplifiedUndercutMode } from 'src/utils/autoPricingUtils';
import { SIMPLIFIED_UNDERCUT_MODE_TO_CID } from 'src/utils/constants/contentIdMaps';
import { AutoPricingUndercutMode } from 'src/WebApiController';

const SIMPLIFIED_UNDERCUTMODE_ORDINALS: Record<SimplifiedUndercutMode, number> =
  {
    [SimplifiedUndercutMode.CheapestListing]: 0,
    [SimplifiedUndercutMode.NthCheapestListing]: 1,
    [SimplifiedUndercutMode.AvgOfNthCheapestListings]: 2,
  };

const sortSimplifiedUndercutModeFn = (a: string, b: string): number =>
  (SIMPLIFIED_UNDERCUTMODE_ORDINALS[a as SimplifiedUndercutMode] ?? 0) -
  (SIMPLIFIED_UNDERCUTMODE_ORDINALS[b as SimplifiedUndercutMode] ?? 0);

export const AutoPricingUnderCutModeSelector = ({
  undercutMode,
  undercutReferenceListingPosition,
  setUndercutModeValues,
  rootStyle,
  disabled,
}: {
  undercutMode: AutoPricingUndercutMode | null;
  undercutReferenceListingPosition: number | null;
  setUndercutModeValues: (
    undercutModeNew: AutoPricingUndercutMode | null,
    undercutReferenceListingPositionNew: number | null
  ) => void;
  rootStyle?: CSSProperties;
  disabled: boolean;
}) => {
  const { simplifiedUndercutMode, onSimplifiedUndercutModeChange } =
    useSimplifiedUndercutMode(
      undercutMode,
      undercutReferenceListingPosition,
      setUndercutModeValues
    );

  return (
    <PosEnumSelect
      style={rootStyle ?? { width: '250px' }}
      value={simplifiedUndercutMode}
      disabled={disabled}
      valueOptionsContent={SIMPLIFIED_UNDERCUT_MODE_TO_CID}
      sortBy="key"
      sortFn={sortSimplifiedUndercutModeFn}
      enableEmptySelection={false}
      onClick={(e) => e.stopPropagation()}
      onChange={(v) => {
        const simplifiedUndercutModeNew = v as SimplifiedUndercutMode;
        onSimplifiedUndercutModeChange(simplifiedUndercutModeNew);
      }}
    />
  );
};
